<script>
</script>

<style lang="scss">
  .wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
  }

  .icon {
    width: 70px;
    height: 133px;
  }

  .text {
    color: hsl(var(--color-N100, var(--color-N77)));
    text-align: center;
    line-height: 28px;

    &-primary {
      font-size: 18px;
      font-weight: 600;
      margin: 0.5em 0;
    }

    &-secondary {
      font-size: 14px;
    }
  }

  .fill-bg {
    fill: hsl(var(--color-N00, var(--color-N04)));
  }

  .fill-accent {
    fill: hsl(var(--color-accent));
  }

  .stroke-accent {
    stroke: hsl(var(--color-accent));
  }

  .stop-accent {
    stop-color: hsla(var(--color-accent));
  }
</style>

<div class="wrapper">
  <div class="icon">
    <svg
      width="71"
      height="134"
      viewBox="0 0 92 174"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.60547 30.1623L46.9517 8.36816L86.595 30.1623V142.864L46.9517 165.051L4.60547 142.864V30.1623Z"
        class="fill-bg" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46.8753 0.272461L91.1009 28.8297V145.842L46.8743 173.146L0.101562 145.918V28.754L46.8753 0.272461ZM9.1114 33.2375V141.476L46.8743 163.407L82.091 141.552V33.1618L46.8753 10.6873L9.1114 33.2375Z"
        class="fill-accent" />
      <path
        opacity="0.6"
        d="M77.8034 35.6281L46.7494 15.5281C46.7182 15.5079 46.6782 15.5072 46.6463 15.5264L13.1021 35.6285C13.0727 35.6461 13.0547 35.6779 13.0547 35.7122V139.179C13.0547 139.214 13.0736 139.247 13.1043 139.264L46.4626 158.1C46.4929 158.117 46.53 158.117 46.5599 158.099L77.7997 139.781C77.8296 139.763 77.848 139.731 77.848 139.696V35.71C77.848 35.6769 77.8312 35.646 77.8034 35.6281Z"
        stroke-width="1.46344"
        class="stroke-accent" />
      <path
        d="M77.4979 118.927H14.128C13.5891 118.927 13.1523 119.364 13.1523 119.902V139.388C13.1523 139.744 13.3465 140.072 13.6588 140.243L46.2655 158.125C46.5652 158.29 46.929 158.285 47.2246 158.114L77.9879 140.248C78.2885 140.073 78.4735 139.752 78.4735 139.404V119.902C78.4735 119.364 78.0368 118.927 77.4979 118.927Z"
        fill="url(#paint0_linear_1708_213100)" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46.3047 59.5869V78.5091H44.8047V59.5869H46.3047Z"
        class="fill-accent" />
      <path
        d="M46.7667 59.3668C46.7667 60.011 46.2444 60.5333 45.6002 60.5333C44.9559 60.5333 44.4336 60.011 44.4336 59.3668C44.4336 58.7225 44.9559 58.2002 45.6002 58.2002C46.2444 58.2002 46.7667 58.7225 46.7667 59.3668Z"
        fill="url(#paint1_linear_1708_213100)" />
      <path
        d="M28.2109 102.441V70.227C28.2109 69.6731 28.66 69.2241 29.2139 69.2241H34.373C34.9269 69.2241 35.3759 69.6731 35.3759 70.227V75.7576C35.3759 76.3115 35.825 76.7606 36.3789 76.7606H40.1175C40.6714 76.7606 41.1204 76.3115 41.1204 75.7576V70.227C41.1204 69.6731 41.5694 69.2241 42.1233 69.2241H49.8768C50.4307 69.2241 50.8798 69.6731 50.8798 70.227V75.7576C50.8798 76.3115 51.3288 76.7606 51.8827 76.7606H56.0537C56.6076 76.7606 57.0566 76.3115 57.0566 75.7576V70.227C57.0566 69.6731 57.5056 69.2241 58.0595 69.2241H62.8482C63.4021 69.2241 63.8511 69.6731 63.8511 70.227V102.441C63.8511 102.995 63.4021 103.444 62.8482 103.444H29.2139C28.66 103.444 28.2109 102.995 28.2109 102.441Z"
        fill="url(#paint2_linear_1708_213100)" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.1289 124.498V86.4419C22.1289 85.888 22.5779 85.439 23.1318 85.439H31.0457C31.5996 85.439 32.0486 85.888 32.0486 86.4419V92.3255C32.0486 92.8794 32.4976 93.3284 33.0515 93.3284H40.6921C41.246 93.3284 41.695 92.8794 41.695 92.3255V88.6218C41.695 88.0679 42.144 87.6189 42.6979 87.6189H49.7397C50.2936 87.6189 50.7426 88.0679 50.7426 88.6218V92.3255C50.7426 92.8794 51.1917 93.3284 51.7456 93.3284H59.4859C60.0398 93.3284 60.4888 92.8794 60.4888 92.3255V86.4419C60.4888 85.888 60.9379 85.439 61.4917 85.439H68.9327C69.4866 85.439 69.9356 85.888 69.9356 86.4419V124.498C69.9356 124.768 69.7172 124.986 69.4478 124.986H52.5537L52.5862 111.444C52.5862 108.272 49.6514 105.7 46.031 105.7C42.4107 105.7 39.4757 108.272 39.4757 111.444L39.4432 124.986H22.6167C22.3473 124.986 22.1289 124.768 22.1289 124.498ZM39.4432 124.986V124.987H52.5537V124.986H39.4432Z"
        fill="url(#paint3_linear_1708_213100)" />
      <rect
        x="63.0742"
        y="112.763"
        width="4.1875"
        height="2.95033"
        rx="0.3"
        class="fill-accent" />
      <rect
        x="22.1289"
        y="110.954"
        width="4.1875"
        height="2.95033"
        rx="0.3"
        class="fill-accent" />
      <rect
        x="24.4961"
        y="114.327"
        width="4.1875"
        height="2.95033"
        rx="0.3"
        class="fill-accent" />
      <rect
        x="28.2109"
        y="79.292"
        width="4.1875"
        height="2.95033"
        rx="0.3"
        class="fill-accent" />
      <rect
        x="32.9141"
        y="83.2178"
        width="4.1875"
        height="2.95033"
        rx="0.3"
        class="fill-accent" />
      <rect
        x="60.9805"
        y="109.155"
        width="4.1875"
        height="2.95033"
        rx="0.3"
        class="fill-accent" />
      <rect
        x="65.75"
        y="106.204"
        width="4.1875"
        height="2.95033"
        rx="0.3"
        class="fill-accent" />
      <path
        d="M30.839 39.5247L28.2028 40.2786C28.0055 40.335 27.9961 40.611 28.189 40.6808L30.9422 41.677C31.0032 41.6991 31.0507 41.7479 31.071 41.8095L32.0475 44.7673C32.1105 44.9582 32.3793 44.9617 32.4473 44.7725L33.5154 41.8013C33.5358 41.7445 33.5796 41.6991 33.6357 41.6766L36.1284 40.6762C36.3121 40.6025 36.303 40.3395 36.1146 40.2787L33.7807 39.5255C33.7193 39.5057 33.6703 39.4589 33.6477 39.3985L32.4487 36.2024C32.3788 36.0161 32.1137 36.0207 32.0502 36.2093L30.9813 39.3888C30.9591 39.4547 30.9059 39.5056 30.839 39.5247Z"
        class="fill-accent" />
      <path
        d="M61.4485 51.266L61.9441 49.2137C61.9965 48.9967 62.3056 48.9983 62.3557 49.2158L62.8285 51.2657C62.8455 51.3395 62.9006 51.3985 62.9731 51.4205L64.9738 52.0286C65.1759 52.09 65.173 52.3771 64.9697 52.4345L62.9766 52.9966C62.9022 53.0176 62.8452 53.0774 62.8279 53.1527L62.3557 55.2039C62.3057 55.4215 61.9964 55.4231 61.9441 55.206L61.4491 53.1523C61.431 53.0773 61.3735 53.018 61.299 52.9978L59.2272 52.4351C59.0212 52.3792 59.0184 52.0881 59.2232 52.0281L61.3024 51.4193C61.375 51.3981 61.4307 51.3396 61.4485 51.266Z"
        class="fill-accent" />
      <path
        d="M65.0301 60.9203L62.6949 60.1605C62.5011 60.0975 62.4998 59.8237 62.6931 59.7589L65.0345 58.9742C65.0969 58.9533 65.146 58.9046 65.1673 58.8423L65.9034 56.6959C65.9698 56.5023 66.2451 56.5065 66.3055 56.7021L67.0071 58.9728C67.0262 59.0345 67.0724 59.0842 67.1327 59.1075L69.2112 59.914C69.3992 59.9869 69.3882 60.2565 69.1949 60.3139L67.1471 60.9214C67.0786 60.9417 67.025 60.9952 67.0046 61.0637L66.3107 63.3922C66.2512 63.5918 65.9693 63.5942 65.9065 63.3956L65.1663 61.0576C65.1457 60.9925 65.095 60.9414 65.0301 60.9203Z"
        class="fill-accent" />
      <defs>
        <linearGradient
          id="paint0_linear_1708_213100"
          x1="45.8129"
          y1="127.747"
          x2="45.8129"
          y2="184.964"
          gradientUnits="userSpaceOnUse">
          <stop class="stop-accent" stop-opacity="0" />
          <stop offset="0.316472" class="stop-accent" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1708_213100"
          x1="45.6002"
          y1="58.3729"
          x2="45.6002"
          y2="61.1875"
          gradientUnits="userSpaceOnUse">
          <stop offset="0.604167" class="stop-accent" />
          <stop offset="1" stop-opacity="0.83" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1708_213100"
          x1="46.0312"
          y1="43.5925"
          x2="46.031"
          y2="102.335"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="white" />
          <stop offset="0.821292" class="stop-accent" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1708_213100"
          x1="46.0332"
          y1="30.6526"
          x2="46.0332"
          y2="129.556"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="white" />
          <stop offset="1" class="stop-accent" />
        </linearGradient>
      </defs>
    </svg>
  </div>
  <div class="text">
    <div class="text-primary">Aura is in another Castle.</div>
    <div class="text-secondary">Go back and try again later.</div>
  </div>
</div>
